'use client';

import { createContext, useContext, type ReactNode } from 'react';

/**
 * Keyboard-shortcut seam for `@naumu/ui`.
 *
 * `ContextMenuItem` renders the shortcut hint for a command id. Resolving an
 * id to a binding lives in the app's keyboard registry, which `@naumu/ui` must
 * not import, so the DS asks this context instead. Web's `KeyboardProvider`
 * supplies the real resolver; without a provider the hint is simply omitted.
 */
export type ShortcutLabelResolver = (commandId: string) => string | null;

const ShortcutLabelContext = createContext<ShortcutLabelResolver>(() => null);

export const ShortcutLabelProvider = ({
	resolve,
	children,
}: {
	resolve: ShortcutLabelResolver;
	children: ReactNode;
}) => (
	<ShortcutLabelContext.Provider value={resolve}>{children}</ShortcutLabelContext.Provider>
);

export const useShortcutLabel = (): ShortcutLabelResolver => useContext(ShortcutLabelContext);
